import { useQuery } from 'react-query';
import fetch from 'lib/fetch';
import SessionStorage from 'services/session-storage';

type AppConfigRequest = {
    SupportUIClientId: string;
    TenantId: string;
    SupportUIRedirectUrl: string;
    SupportUiApiBaseUrl: string;
    SupportUiApiClientId: string;
    FotaSecurityGroupId: string;
    SupportAdminSecurityGroupId: string;
    EnvironmentDisplayName: string;
};

export type AppConfig = {
    SUPPORT_UI_CLIENT_ID: string;
    TENANT_ID: string;
    SUPPORT_UI_REDIRECT_URL: string;
    PROXY_API_CLIENT_ID: string;
    PROXY_API_BASE_URL: string;
    FOTA_SECURITY_GROUP_ID: string;
    SUPPORTADMIN_SECURITY_GROUP_ID: string;
    SUPPORT_UI_ENVIRONMENT_DISPLAY_NAME: string;
};

export const fetchAppSettings = async () => {
    // Fetch env config in prod
    const {
        SupportUIClientId,
        TenantId,
        SupportUIRedirectUrl,
        SupportUiApiBaseUrl,
        SupportUiApiClientId,
        FotaSecurityGroupId,
        SupportAdminSecurityGroupId,
        EnvironmentDisplayName
    } = await fetch<AppConfigRequest>('/env.json');

    // Fallback to process.env.<variable> in dev mode
    const config = {
        SUPPORT_UI_CLIENT_ID:
            SupportUIClientId || 
            process.env.REACT_APP_SupportUIClientId || 
            '',
        TENANT_ID: 
            TenantId || 
            process.env.REACT_APP_TenantId || 
            '',
        SUPPORT_UI_REDIRECT_URL:
            SupportUIRedirectUrl ||
            process.env.REACT_APP_SupportUIRedirectUrl ||
            '',
        PROXY_API_CLIENT_ID:
        SupportUiApiClientId ||
            process.env.REACT_APP_SupportUiApiClientId ||
            '',
        PROXY_API_BASE_URL:
            SupportUiApiBaseUrl ||
            process.env.REACT_APP_SupportUiApiBaseUrl ||
            '',
        FOTA_SECURITY_GROUP_ID:
            FotaSecurityGroupId ||
            process.env.REACT_APP_FotaSecurityGroupId ||
            '',
        SUPPORTADMIN_SECURITY_GROUP_ID:
            SupportAdminSecurityGroupId ||
            process.env.REACT_APP_SupportAdminSecurityGroupId ||
            '',
        SUPPORT_UI_ENVIRONMENT_DISPLAY_NAME:
            EnvironmentDisplayName || 
            process.env.REACT_APP_EnvironmentDisplayName || 
            '',
    };
    // Save config to sessionStorage
    SessionStorage.setItem('config', config);
    return config;
};

export default function useAppConfig() {
    const { data: config, ...rest } = useQuery('/appconfig', fetchAppSettings, {
        refetchOnWindowFocus: false
    });

    return { config, ...rest };
}
